import { Injectable } from '@angular/core';
import { State, getSegmentsReport, getSegmentsOptions } from '../../reducers';
import { State as ReportState } from '../../reducers/invoices/reducers-segments-report';
import { Store, select } from '@ngrx/store';
import { BackendInvoiseService } from '../backend-invoice.service';
import { Observable, combineLatest, of } from 'rxjs';
import { Report } from '../../models/invoices/segments.report.model';
import { map, shareReplay, filter, switchMap, tap, withLatestFrom, catchError, startWith } from 'rxjs/operators';
import { Receive } from '../../actions/invoices/actions-segments-report';
import * as CoreActions from '@uxdf/direct-shared-lib';

@Injectable({
  providedIn: 'root'
})
export class SegmentsReportService {
  private reportState$: Observable<ReportState>;
  private fetchedReportState$: Observable<Report | any>;
  private report$: Observable<ReportState>;

  constructor(private readonly store: Store<State>, private readonly backendInvoiceService: BackendInvoiseService) {}

  public getReport(): Observable<ReportState> {
    if (!this.report$) {
      this.initObservables();
      this.report$ = combineLatest([this.fetchedReportState$, this.reportState$]).pipe(
        map(([_, reportState]) => reportState),
        shareReplay(1)
      );
    }

    return this.report$;
  }

  private initObservables() {
    this.reportState$ = this.store.pipe(select(getSegmentsReport));
    this.fetchedReportState$ = this.reportState$.pipe(
      filter(reportState => reportState.updateRequired),
      withLatestFrom(this.store.pipe(select(getSegmentsOptions))),
      map(([_, optionsState]) => optionsState.data),
      filter(options => !!(options.dateFrom && options.dateTo && options.offices.length)),
      switchMap(options => this.backendInvoiceService.getInvoicesReport(options)),
      catchError(error => {
        if (error && error.error !== undefined && (+error.error.code === 40 || +error.error.code === 42)) {
          return of(new CoreActions.DirectUserRoleHasBeenChanged());
        }

        this.store.dispatch(new Receive({ report: {} as Report, errorMessage: error.message }));
        return this.fetchedReportState$;
      }),
      tap((response: Report) => {
        this.store.dispatch(new Receive({ report: response, errorMessage: '' }));
      })
    );
  }
}
